const DEFAULT_PROD_FRONTEND = 'https://learning.vigilantium.com';

function isLocalhostUrl(url: string): boolean {
  return /^(https?:\/\/)?(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(url || '');
}

/**
 * URL pública del portal para enlaces compartibles (reset password, etc.).
 * Nunca usa localhost: los destinatarios no podrían abrirlo.
 */
export function getPublicFrontendBaseUrl(): string {
  const envUrl = (process.env.REACT_APP_FRONTEND_URL || '').trim().replace(/\/+$/, '');
  const origin =
    typeof window !== 'undefined' ? window.location.origin.replace(/\/+$/, '') : '';

  if (envUrl && !isLocalhostUrl(envUrl)) {
    return envUrl;
  }
  if (origin && !isLocalhostUrl(origin)) {
    return origin;
  }
  return DEFAULT_PROD_FRONTEND;
}

export function buildPasswordResetLink(resetToken: string): string {
  const base = getPublicFrontendBaseUrl();
  return `${base}/reset-password?token=${encodeURIComponent(resetToken)}`;
}
